import React from "react";
import { Text } from 'spectacle';

const GoogleLogo = props => (
  // <svg
  //   width={props.size ? props.size : "90%"}
  //   height={props.size ? props.size : "90%"}
  //   viewBox="0 0 256 256"
  //   preserveAspectRatio="xMinYMin meet"
  //   {...props}
  // >
  //   <path
  //     d="M81.558 190.482l-44.94-77.835 44.94-77.836h89.876l44.939 77.836-44.94 77.835H81.559"
  //     fill="#CAC9C2"
  //   />
  //   <path
  //     d="M127.997 148.176c-19.315 0-35.028-15.714-35.028-35.029 0-19.314 15.713-35.027 35.028-35.027 19.314 0 35.027 15.713 35.027 35.027 0 19.315-15.713 35.029-35.027 35.029"
  //     fill="#FFF"
  //   />
  //   <path
  //     d="M198.465 8.716C195.71 3.946 188.95.044 183.443.044H72.7c-5.508 0-12.268 3.903-15.021 8.672L25.32 64.764c-.254 3.621.41 7.403 2.007 10.167l21.904 37.45L88.332 44.83h123.59c2.924 0 6.196 1.107 9.04 2.851L198.465 8.716"
  //     fill="#5072AA"
  //   />
  //   <path
  //     d="M26.727 62.311l-1.416 2.453c-.254 3.621.41 7.403 2.006 10.167l21.904 37.45L60.875 92.25 26.727 62.311"
  //     fill="#4D6796"
  //   />
  //   <path
  //     d="M75.554 28.837a6.766 6.766 0 0 1-6.758-6.758 6.766 6.766 0 0 1 6.758-6.758 6.765 6.765 0 0 1 6.759 6.758 6.766 6.766 0 0 1-6.759 6.758m110.742-6.758a6.258 6.258 0 1 1-12.515 0 6.258 6.258 0 0 1 12.515 0z"
  //     fill="#FFF"
  //   />
  //   <path
  //     d="M253.837 104.624L220.962 47.68c-2.844-1.744-6.116-2.85-9.04-2.85h-44.568l38.537 67.924-61.012 107.794c-1.343 2.324-3.639 4.439-6.275 6h44.839c5.508 0 12.268-3.903 15.022-8.672l55.372-95.907c2.755-4.77 2.755-12.575 0-17.345"
  //     fill="#CC4232"
  //   />
  //   <path
  //     d="M222.446 50.235l-1.474-2.555c-2.842-1.744-6.114-2.85-9.038-2.85h-44.568l11.6 20.447 43.48-15.042"
  //     fill="#B23F33"
  //   />
  //   <path
  //     d="M180.038 209.982a6.766 6.766 0 0 1-6.758-6.759 6.766 6.766 0 0 1 6.758-6.758 6.766 6.766 0 0 1 6.759 6.758 6.766 6.766 0 0 1-6.759 6.759m52.596-90.076a6.766 6.766 0 0 1-6.759-6.759 6.766 6.766 0 0 1 6.759-6.758 6.766 6.766 0 0 1 6.758 6.758 6.765 6.765 0 0 1-6.758 6.759"
  //     fill="#FFF"
  //   />
  //   <g>
  //     <path
  //       d="M89.184 180.69L27.327 74.93c-1.596-2.764-2.26-6.546-2.007-10.167l-23.013 39.86c-2.754 4.77-2.754 12.575 0 17.345l55.372 95.907c2.753 4.769 9.513 8.671 15.021 8.671h65.904c2.636-1.56 4.932-3.675 6.275-6l22.559-39.857H89.184"
  //       fill="#ECB02A"
  //     />
  //     <path
  //       d="M134.857 226.547h3.833c2.637-1.56 4.932-3.675 6.274-6l22.56-39.857H143.5l-8.643 45.857"
  //       fill="#C79732"
  //     />
  //     <path
  //       d="M75.554 209.982a6.766 6.766 0 0 1-6.758-6.759 6.766 6.766 0 0 1 6.758-6.758 6.765 6.765 0 0 1 6.759 6.758 6.765 6.765 0 0 1-6.759 6.759m-52.689-90.076a6.766 6.766 0 0 1-6.759-6.759 6.766 6.766 0 0 1 6.759-6.758 6.766 6.766 0 0 1 6.758 6.758 6.766 6.766 0 0 1-6.758 6.759"
  //       fill="#FFF"
  //     />
  //   </g>
  // </svg>
  <Text bgColor="#CC4232" bold textColor="#FFF" lineHeight={props.lineHeight ? props.lineHeight: 1}> Google Cloud Platform </Text>
);

export default GoogleLogo;



// WEBPACK FOOTER //
// ./src/GoogleLogo.js